module.exports = __webpack_public_path__ + "static/img/mdm_register4.f1d3b28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tip/mdm_register4.jpg
// module id = 7bpU
// module chunks = 68